export default "__VITE_ASSET__CJNiQPwj__"